import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "../components/notFound";
import { Loader } from "../components/ui/loaders";
import { PrivateRoute } from "./private";
import { privateRoutes } from "./private/routes";
import { PublicRoute } from "./public";
import { publicRoutes } from "./public/router";

export default function AppRouter() {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<PublicRoute />}>
          {publicRoutes.map((route) => {
            const Comp = route.component;
            return (
              <Route key={route.name} path={route.path} element={<Comp />} />
            );
          })}
        </Route>

        <Route element={<PrivateRoute />}>
          {privateRoutes.map((route) => {
            const Comp = route.component;
            return (
              <Route key={route.name} path={route.path} element={<Comp />} />
            );
          })}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
